import React, {useContext, useRef, useState} from 'react'
import {makeStyles, Tooltip, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpansionPanel from 'components/ExpansionPanel';
import ArrowIcon from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import OfferPositionForm from "./components/OfferPositionForm";
import {connect} from "react-redux";
import Button from "components/Button";
import {OfferPositionStatusToAvatar} from "../../../../common/constants/OfferPositionStatusType";
import scrollTo from "libs/scrollTo";
import WorkableButton from "components/button/WorkableButton";
import {OfferMode} from "../../../../common/constants/OfferMode";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {RoundType} from "constants/RoundType";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import {simpleConfirm} from "libs/ConfirmNotification";
import SupportModeContext from "context/SupportModeContext";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import {useParams} from "react-router";
import PrintIcon from '@material-ui/icons/Print';


const useStyle = makeStyles(theme => ({
    root: {
        // backgroundColor: theme.palette.background.default,
        marginBottom: theme.spacing(),
        border: `solid 1px ${theme.palette.border.dark}`,
        '&.MuiAccordion-rounded:first-child .MuiAccordionSummary-root': {
            borderRadius: theme.spacing(1.5, 1.5, 0, 0)
        },
        '&.MuiAccordion-rounded:last-child ': {
            marginBottom: 0,
        },
        '&.MuiAccordion-rounded:last-child .MuiAccordionSummary-root': {
            borderRadius: theme.spacing(0, 0, 1.5, 1.5)
        },
        '&.MuiAccordion-rounded:only-child .MuiAccordionSummary-root': {
            borderRadius: theme.spacing(1.5)
        }
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    rootGrid: {
        '&>*:last-child': {
            flexGrow: 1,
        }
    },
    adornmentGrid: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2)
        }
    },
    title: {
        top: 105,
        zIndex: theme.zIndex.appBar - 2,
        position: "sticky",
        background: theme.palette.background.default,
    },
    titleGrid: {
        '&>*:first-child': {
            flexGrow: 10000,
        }
    },
    discardButton: {
        marginRight: theme.spacing(2),
        whiteSpace: "nowrap"

    }
}))

function OfferMultiPositions(
    {
        position,
        positionsLoaded,
        mode,
        disabled,
        formValues,
        formSubmit,
        roundType,
        offerEdit,
        hide,
    }) {
    const classes = useStyle();
    const panelRef = useRef();
    const FORM_ID = "offerPositionForm_" + position.positionId
    const [expanded, setExpanded] = useState(false);
    const [working, setWorking] = useState(false);
    const supportMode = useContext(SupportModeContext);
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const params = useParams();

    const handleClick = position => {
        setExpanded(x => !x)
    }

    const printOfferPosition = () => {
        DemandOffersOfferService.printOfferPosition(params.id, params.stageId, mode, position.positionId, purchaserOfferContext?.supplierId, purchaserOfferContext?.preview)
    }

    const createTitle = (variant, label, position) => {
        return (<div>

                <GridBlock alignItems="center" justify="space-between" className={classes.rootGrid}>
                    <GridBlock alignItems="center" wrap="nowrap">
                        <ExpansionPanelTitleAvatar variant={variant} title={position.statusTranslated}/>
                        <Typography variant='h6'>
                            {label}
                        </Typography>
                    </GridBlock>

                    <GridBlock
                        wrap='nowrap'
                        className={classes.adornmentGrid}
                        alignItems='center'
                        justify="flex-end"
                    >
                        {!disabled && !offerEdit.passiveOfferForm && <GridBlock justify="flex-end">
                            {
                                purchaserOfferContext?.preview && <WorkableButton
                                    className={classes.discardButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        printOfferPosition();
                                    }} Icon={PrintIcon} working={working}>{Tr('download_print')}</WorkableButton>
                            }


                            {formValues[FORM_ID + "_dirty"] &&
                                <Button className={classes.discardButton} variant="outlined" onClick={(e) => {
                                    e.stopPropagation();
                                    simpleConfirm("discard_changes_confirm", formSubmit[FORM_ID + "_reset"]);
                                }} disabled={working || !expanded}>{Tr('discard_changes')}</Button>}

                            <WorkableButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    formSubmit[FORM_ID]()

                                    setTimeout((formId) => scrollTo("#" + formId + " .MuiFormHelperText-root.Mui-error", 200), 100, FORM_ID);
                                }} disabled={working || !expanded || (!formValues[FORM_ID + "_dirty"] && positionsLoaded[DemandOffersOfferService.getLoadedPositionKey(position.positionId)]?.status !== 'PLACED_OUT_OF_DATE') || supportMode || purchaserOfferContext?.preview}
                                working={working}>{Tr('save')}</WorkableButton>


                        </GridBlock>}

                        <Tooltip title={expanded ? Tr('collapse') : Tr('expand')} placement='top'>
                            <ArrowIcon
                                className={clsx({
                                    [classes.rotate]: !expanded
                                })}
                            />
                        </Tooltip>
                    </GridBlock>
                </GridBlock>
                {(!!position.endDate || !!position.offerTmpDate || !!position.offerDate) &&
                    <GridBlock justify="space-between">
                        {!!position.endDate && <Typography>
                            {Tr(RoundType.AUCTION === roundType ? 'additional_round_end_date_auction' : 'additional_round_end_date')}: {moment(position.endDate).format(DateFormats.DATETIME_FORMAT)}
                        </Typography>
                        }
                        {(mode === OfferMode.EDIT) && !!position.offerTmpDate && <Typography>
                            {Tr('offer_tmp_date_additional')}: {moment(position.offerTmpDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                        </Typography>
                        }
                        {(mode === OfferMode.PLACED) && !!position.offerDate && <Typography>
                            {Tr(RoundType.AUCTION === roundType ? 'offer_date_additional_auction' : 'offer_date_additional')}: {moment(position.offerDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                        </Typography>
                        }
                    </GridBlock>
                }

            </div>
        )
    }


    const variant = OfferPositionStatusToAvatar(position.status, mode);
    const _label = position.name;
    return (
        <ExpansionPanel
            id={`wrap_${FORM_ID}`}
            hide={hide}
            classesObj={classes}
            panelRef={panelRef}
            disabled={variant === 'Wait'}
            title={createTitle(variant, _label, position)}
            expanded={expanded}
            onChange={() => handleClick(position)}
        >
            <OfferPositionForm
                working={working}
                setWorking={setWorking}
                expanded={expanded}
                setExpanded={setExpanded}
                position={position}
                loadedPosition={positionsLoaded[DemandOffersOfferService.getLoadedPositionKey(position.positionId)]}
                formId={FORM_ID}
                mode={mode}
                disabled={disabled}
                roundType={roundType}
                offerEdit={offerEdit}
            />
        </ExpansionPanel>

    )

}

OfferMultiPositions.propTypes = {
    position: PropTypes.any,
    positionsLoaded: PropTypes.object.isRequired,
    mode: PropTypes.oneOf(Object.keys(OfferMode)).isRequired,
    disabled: PropTypes.bool.isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
}

export default connect((state) => ({
    formValues: state.formValues,
    formSubmit: state.form,
}), {})(OfferMultiPositions);